import 'intersection-observer';
import { useState } from 'react';
import { useInViewEffect } from 'react-hook-inview';
import { getScrollParent } from '../utils/get-scroll-parent';

export type LazyDetectorProps = {
  className?: string;
  onChange: (inView: boolean) => void;
  unobserve?: boolean;
  // 格式'0px 0px 0px 0px'
  rootMargin?: string;
};

/**
 * 判断是否进出最近一个原生滚动条父节点可视区域
 * ```
 * 1. unobserve表示触发监听后，是否销毁监听功能
 * ```
 */
export const InVisibleView = (props: LazyDetectorProps) => {
  const [scrollParentNode, setScrollParentNode] = useState<HTMLDivElement | Document>();
  const inViewCallback = useInViewEffect(
    ([entry], observer) => {
      if (entry.isIntersecting) {
        if (props.unobserve) {
          observer.unobserve(entry.target);
        }
      }
      props.onChange(entry.isIntersecting);
    },
    {
      // 设置了root属性后，rootMargin才会有效果，rootMagin可以理解为，懒加载的预加载距离【https://zhuanlan.zhihu.com/p/391152610】
      rootMargin: props.rootMargin,
      // root属性指定目标元素所在的滚动容器节点
      root: scrollParentNode === document ? undefined : scrollParentNode,
    },
  );

  return (
    <div
      className="v-in-visible-view"
      style={{ width: '100%' }}
      ref={(node) => {
        if (node) {
          setScrollParentNode(getScrollParent(node as Element, document) as HTMLDivElement);
          inViewCallback(node);
        }
      }}
    />
  );
};
